import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const severityConfig = {
  critical: { icon: ErrorOutlineIcon, color: '#DC2626' },
  warning: { icon: WarningAmberIcon, color: '#D97706' },
  info: { icon: InfoOutlinedIcon, color: '#6B7280' },
};

const RiskAlertHistory = ({ alerts }) => {
  return (
    <Card sx={{ borderRadius: 1, flex: 1 }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <WarningAmberIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
            Risk Alert History
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {alerts.map((alert, index) => {
            const config = severityConfig[alert.severity] || severityConfig.info;
            const Icon = config.icon;
            return (
              <Box
                key={alert.id}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  py: 1.5,
                  borderBottom: index < alerts.length - 1 ? '1px solid #F3F4F6' : 'none',
                }}
              >
                <Icon sx={{ fontSize: 20, color: config.color, mt: 0.25, flexShrink: 0 }} />
                <Box>
                  <Typography sx={{ fontSize: '0.8125rem', color: '#1B2A3D', lineHeight: 1.5 }}>
                    {alert.title}
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF', mt: 0.25 }}>
                    {alert.timeAgo}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default RiskAlertHistory;
